import { useGetFormConfigQuery } from '@/features/config/configApi';
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import { Grid } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import FormikTextField from '../FormikTextField';
import { InsightSelectFormikWrapper } from '../InsightSelectFormikWrapper';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { getGridLayout } from '@/utils/fieldLayout';
import FormikDateField from '../FormikDateField';
import OptionSelectField from '../OptionSelectField';
import ClientFormField from '@/utils/fieldLayout/ClientFormField';
import { isProspectFieldVisible } from '@/features/config/helper';

const GROUP = 'clientInfo';

const ClientInfoFields = ({ disabled }) => {
	const { view, fieldDensity, isProspect } = useClientSchemaContext();

	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails } = useGetUserDetailsQuery(
		{ email },
		{
			skip: !email,
		},
	);

	const fieldsQuery = useGetFormConfigQuery(
		{ configType: 'client' },
		{
			skip: !userDetails,
			selectFromResult: ({ data, ...rest }) => ({
				...rest,
				data:
					data?.filter(
						(f) =>
							f.group === GROUP &&
							(isProspect ? isProspectFieldVisible(f, view) : f.visible?.[view]),
					) ?? [],
			}),
		},
	);

	const fields = useMemo(() => {
		const data = (fieldsQuery.data ?? []).slice();
		return data.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0));
	}, [fieldsQuery.data]);

	const sizeSchema = useMemo(() => getGridLayout(fields, fieldDensity), [fields, fieldDensity]);

	const getField = useCallback(
		(field) => {
			const size = sizeSchema[field.name];

			return (
				<Grid {...{ size }} key={field.name}>
					<ClientFormField {...{ field, disabled }} />
				</Grid>
			);
		},
		[fields, disabled, sizeSchema],
	);

	if (fields.length === 0) return <></>;

	return (
		<Grid container rowSpacing={1} columnSpacing={2}>
			{fields.map((field) => getField(field))}
		</Grid>
	);
};
export default ClientInfoFields;
